import { render, staticRenderFns } from "./LamisilPage.vue?vue&type=template&id=b34e0e70"
import script from "./LamisilPage.vue?vue&type=script&lang=js"
export * from "./LamisilPage.vue?vue&type=script&lang=js"
import style0 from "./LamisilPage.vue?vue&type=style&index=0&id=b34e0e70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports